import { css } from '@emotion/react'
import { Flow, Heading, Table, TableBody, TableCell, TableRow, Text } from 'bold-ui'
import { Divider } from 'components/divider/Divider'
import { HLabel } from 'components/HLabel'
import { TableBox } from 'components/table'
import { format } from 'date-fns'
import { useErratasNotasComplementaresByAtendimentoProfissionalIdQuery } from 'graphql/hooks.generated'
import { Fragment } from 'react'
import { tipoErrataNotaComplementarRecord } from 'view/errata-nota-complementar/model-errataNotaComplementar'
import { getTipoErrataNotaComplementarByJustificativa } from 'view/errata-nota-complementar/utils-errataNotaComplementar'

interface HistoricoErrataNotaComplementarPanelProps {
  atendimentoProfissionalId: string
}

export default function HistoricoErrataNotaComplementarPanel(
  props: Readonly<HistoricoErrataNotaComplementarPanelProps>
) {
  const { atendimentoProfissionalId } = props

  const { data } = useErratasNotasComplementaresByAtendimentoProfissionalIdQuery({
    variables: {
      atendimentoProfissionalId,
    },
  })

  const erratasNotasComplementares = data?.erratasNotasComplementaresByAtendimentoProfissionalId

  if (!erratasNotasComplementares || erratasNotasComplementares.length === 0) {
    return null
  }

  return (
    <Fragment>
      <Divider style={styles.divider} />
      <Heading style={styles.heading} level={3}>
        Erratas e notas complementares
      </Heading>
      <TableBox>
        <Table>
          <TableBody>
            {erratasNotasComplementares.map((errata) => {
              const lotacao = errata?.lotacao
              return (
                <TableRow key={errata?.id}>
                  <TableCell style={styles.cell}>
                    <Flow direction='vertical' gap={0.25}>
                      <HLabel
                        title={`${
                          tipoErrataNotaComplementarRecord[
                            getTipoErrataNotaComplementarByJustificativa(errata?.justificativa)
                          ]
                        }:`}
                      >
                        {errata?.descricaoErrataNotaComplementar}
                      </HLabel>
                      <Text fontStyle='italic'>
                        Registrado por
                        <Text>
                          {' '}
                          {lotacao?.profissional?.nome}
                          {lotacao?.cbo && ` | ${lotacao.cbo.cbo2002} - ${lotacao.cbo.nome.titleCase()}`}
                          {lotacao?.equipe?.ine ? ` | ${lotacao.equipe.nome} - ${lotacao.equipe.ine}` : ' | Sem equipe'}
                          {` em ${format(errata?.data, "dd/MM/yyyy' às 'HH:mm")}`}
                        </Text>
                      </Text>
                    </Flow>
                  </TableCell>
                </TableRow>
              )
            })}
          </TableBody>
        </Table>
      </TableBox>
    </Fragment>
  )
}

const styles = {
  divider: css`
    margin: 1rem -1rem;
  `,
  cell: css`
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
    overflow-wrap: anywhere;
  `,
  heading: css`
    padding-bottom: 0.5rem;
  `,
}
